import React from 'react';
import { AlertTriangle, CreditCard } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { usePricing } from '../contexts/PricingContext';
import { Link } from 'react-router-dom';

/**
 * Shows a warning banner when the company is in a billing grace period.
 * Rendered inside the Sidebar layout so it appears on all authenticated pages.
 */
const GracePeriodBanner = () => {
  const { user } = useAuth();
  const { billing } = usePricing();

  // /billing-status is live; user.grace_period is only as fresh as the last
  // login, so prefer the former and keep the latter as a fallback.
  const gracePeriod = billing?.grace_period
    ? { active: true, days_remaining: billing.days_remaining, message: billing.message }
    : user?.grace_period;
  if (!gracePeriod?.active) return null;

  return (
    <div className="mx-4 mt-4 mb-0">
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-amber-900">Payment Method Needs Updating</p>
          <p className="text-sm text-amber-700 mt-1">
            {gracePeriod.message || `You have ${gracePeriod.days_remaining} days to update your payment method before access is restricted.`}
          </p>
          <Link
            to="/admin/billing"
            className="inline-flex items-center gap-1.5 mt-2 text-sm font-medium text-amber-800 hover:text-amber-900 underline"
          >
            <CreditCard className="w-4 h-4" />
            Update Payment Method
          </Link>
        </div>
        <span className="flex-shrink-0 px-2.5 py-1 bg-amber-200 text-amber-800 text-xs font-bold rounded-full">
          {gracePeriod.days_remaining}d left
        </span>
      </div>
    </div>
  );
};

export default GracePeriodBanner;
